import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import {
  getAccountingReportDetails,
  getReports,
} from "../../../../redux/actions/api/apiAction";
import { useDispatch, useSelector } from "react-redux";

const XLSX = window.XLSX;

export const values = {
  details: {
    subscriptions: {
      ID: (row) => row?.id,
      "Package Name": (row) => row?.packageName || "-",
      "Member Name": (row) => row?.memberName,
      "Purchase Date": (row) =>
        moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      "Subscription Status": (row) => {
        let status = "";
        if (row?.isVoided != "0") status = row?.status;
        if (row?.isAfterReturn) status = "Returned";
        if (row?.isUpgraded) status = "Upgraded";
        if (row?.upgradedFromPackage) status = "Upgraded To";

        return status;
      },
      "Start Date": (row) =>
        moment(row?.startDate).format("DD-MM-YYYY hh:mm:ss A"),
      "End Date": (row) => moment(row?.endDate).format("DD-MM-YYYY hh:mm:ss A"),
      Price: (row) =>
        (row?.paymentType == "Complimentary"
          ? row?.packagePrice
          : row?.purchasedPackagePrice) * (row?.quantity || 1) || 0,
      "Discount Amount": (row) =>
        parseFloat(
          (
            ((row?.paymentType == "Complimentary" ? 100 : row.discount) *
              (row?.paymentType == "Complimentary"
                ? row?.packagePrice
                : row.purchasedPackagePrice) *
              (row.quantity || 1)) /
            100
          ).toFixed(2)
        ),
      Subtotal: (row) => {
        const discountedAmount =
          (row.purchasedPackagePrice * (row.quantity || 1) * row.discount) /
          100;
        return (
          row.purchasedPackagePrice * (row.quantity || 1) - discountedAmount
        );
      },
      "Received Amount": (row) =>
        row.isAfterReturn || row?.isVoided ? 0 : row?.recievedAmount || 0,
      "Remaining Amount": (row) => row?.remainingAmount || 0,
      "Return Amount": (row) => {
        if (row?.isAfterReturn) row.returnAmount = Math.abs(row?.returnAmount);
        return row?.returnAmount + row?.returnedAmountFromUpgraded || 0;
      },
      "Voided Amount": (row) => {
        if (row.isVoided) return row?.recievedAmount * -1;
      },
      "Net Amount": (row) => {
        if (row?.isAfterReturn) {
          row.returnAmount = Math.abs(row?.returnAmount);
          row.recievedAmount = 0;
        }

        if (row.isVoided) {
          if (row?.voidedOnSameDay == 'sameDay') return 0
          else return row?.recievedAmount
        }
        return (
          row.recievedAmount -
          row?.returnAmount
        );
      },
      "Payment Type": (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";
            break;
          case "L":
            type = "Cash";
            break;
          case "BA":
            type = "Bank";
            break;
          case "CO":
            type = "Complimantry";
            break;
          case "SP":
            type = "Split";
            break;
          default:
            type = row?.paymentType;
            break;
        }
        return type;
      },
      "Upgraded From Package Name": (row) => row?.upgradedFromPackage,
      "Upgraded To Package Name": (row) => row?.upgradedToPackage,
      "Transfered From Member": (row) => row?.transferedFromMemberName,
      "Transfered To Member": (row) => row?.transferedMemberName,
      Note: (row) => {
              let note =row.note
              if(!note.trim()){
                if(row.isTransfered){
                  note=`Transfered To ${row?.transferedMemberName} at ${moment(row?.transferedDate).format("DD/MM/YYYY")}` 
                }
                else if(row?.transferedFrom){
                  note=`Transfered from ${row?.transferedFromMemberName}}` 
                }
                else note="N/A"
              }
              return note
            },
      "Created By": (row) => row?.createdBy || "---",
      "Assigned Trainer": (row) => row?.assignedTrainer || "----",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),

    },
    pt: {
      ID: (row) => row?.id,
      "Package Name": (row) => row?.packageName || "-",
      "Member Name": (row) => row?.memberName,
      "Purchase Date": (row) =>
        moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      "Subscription Status": (row) => {
        let status = "";
        if (row?.isVoided != "0") status = row?.status;
        if (row?.isAfterReturn) status = "Returned";
        if (row?.isUpgraded) status = "Upgraded";
        if (row?.upgradedFromPackage) status = "Upgraded To";
        return status;
      },
      "Start Date": (row) =>
        moment(row?.startDate).format("DD-MM-YYYY hh:mm:ss A"),
      "End Date": (row) => moment(row?.endDate).format("DD-MM-YYYY hh:mm:ss A"),
      Price: (row) =>
        (row?.paymentType == "Complimentary"
          ? row?.packagePrice
          : row?.purchasedPackagePrice) * (row.quantity || 1) || 0,
      "Discount Amount": (row) =>
        parseFloat(
          (
            ((row?.paymentType == "Complimentary" ? 100 : row.discount) *
              (row?.paymentType == "Complimentary"
                ? row?.packagePrice
                : row.purchasedPackagePrice) *
              (row.quantity || 1)) /
            100
          ).toFixed(2)
        ),
      Subtotal: (row) => {
        const discountedAmount =
          (row.purchasedPackagePrice * (row.quantity || 1) * row.discount) /
          100;
        return (
          row.purchasedPackagePrice * (row.quantity || 1) - discountedAmount
        );
      },

      "Received Amount": (row) =>
        row.isAfterReturn || row?.isVoided ? 0 : row?.recievedAmount || 0,
      "Remaining Amount": (row) => row?.remainingAmount || 0,
      "Return Amount": (row) => {
        if (row?.isAfterReturn) row.returnAmount = Math.abs(row?.returnAmount);
        return row?.returnAmount + row?.returnedAmountFromUpgraded || 0;
      },
      "Voided Amount": (row) => {
        if (row.isVoided) return row?.recievedAmount * -1;
      },
      "Net Amount": (row) => {
        if (row?.isAfterReturn) {
          row.returnAmount = Math.abs(row?.returnAmount);
          row.recievedAmount = 0;
        }
        if (row.isVoided) {
          if (row?.voidedOnSameDay == 'sameDay') return 0
          else return row?.recievedAmount
        }
        return (
          row.recievedAmount -
          row?.returnAmount
        );
      },
      "Payment Type": (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";
            break;
          case "L":
            type = "Cash";
            break;
          case "BA":
            type = "Bank";
            break;
          case "CO":
            type = "Complimantry";
            break;
          case "SP":
            type = "Split";
            break;
          default:
            type = row?.paymentType;
            break;
        }
        return type;
      },
      "Upgraded From Package Name": (row) => row?.upgradedFromPackage,
      "Upgraded To Package Name": (row) => row?.upgradedToPackage,
      "Transfered From Member": (row) => row?.transferedFromMemberName,
      "Transfered To Member": (row) => row?.transferedMemberName,
      Note: (row) => {
              let note =row.note
              if(!note.trim()){
                if(row.isTransfered){
                  note=`Transfered To ${row?.transferedMemberName} at ${moment(row?.transferedDate).format("DD/MM/YYYY")}` 
                }
                else if(row?.transferedFrom){
                  note=`Transfered from ${row?.transferedFromMemberName}}` 
                }
                else note="N/A"
              }
              return note
            },
      "Created By": (row) => row?.createdBy || "---",
      "Assigned Trainer": (row) => row?.assignedTrainer || "----",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),

    },
    jf: {
      ID: (row) => row?.id,
      "Member Name": (row) => row?.name,
      "Joining Date": (row) =>
        moment(row?.createdAt).format("DD-MM-YYYY hh:mm:ss A"),
      "Payment Type": (row) => {
        let type = row?.paymentType;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";
            break;
          case "L":
            type = "Cash";
            break;
          case "BA":
            type = "Bank";
            break;
          case "CO":
            type = "Complimantry";
            break;
          case "SP":
            type = "Split";
            break;
          default:
            break;
        }
        return type;
      },
      "Received Amount": (row) => (row.isVoided && row?.voidedOnSameDay == "sameDay" ? 0 : row?.recievedAmount || 0),
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),

    },
    retail: {
      ID: (row) => row?.id,
      "Product Name": (row) => row?.productName || "-",
      "Product Category": (row) => row.category || "-",
      "Member Name": (row) => row?.memberName,
      "Purchase Date": (row) =>
        moment(parseInt(row?.createdAt)).format("DD-MM-YYYY hh:mm:ss A"),
      Status: (row) => (row?.isAfterReturn == 1 ? "Returned" : ""),
      Price: (row) => row?.productPrice,
      Cost: (row) => row?.cost,
      Quantity: (row) => row.quantity || 1,
      "Discount Amount": (row) =>
        parseFloat(
          (
            ((row?.paymentType == "Complimentary" ? 100 : row.discount) *
              (row?.paymentType == "Complimentary"
                ? row?.productPrice
                : row.purchasedPrice) *
              (row.quantity || 1)) /
            100
          ).toFixed(2)
        ),
      Subtotal: (row) => {
        const discountedAmount =
          (row.purchasedPrice * (row.quantity || 1) * row.discount) / 100;
        return row.purchasedPrice * (row.quantity || 1) - discountedAmount;
      },
      "Payment Type": (row) => {
        let type;
        switch (row?.paymentType) {
          case "CC":
            type = "Visa";
            break;
          case "L":
            type = "Cash";
            break;
          case "BA":
            type = "Bank";
            break;
          case "CO":
            type = "Complimantry";
            break;
          case "SP":
            type = "Split";
            break;
          default:
            type = row?.paymentType;
            break;
        }
        return type;
      },

      "Received Amount": (row) => {
        if (row.isAfterReturn) {
          return 0;
        } else {
          return row?.recievedAmount || 0;
        }
      },
      "Returned Amount": (row) => {
        if (row?.isAfterReturn) return Math.abs(row.recievedAmount);
        else return 0;
      },
      "Net Amount": (row) => {
        return row.recievedAmount;
      },
      "Remaining Amount": (row) => row?.remainingAmount || 0,
      "Created By": (row) => row?.createdBy || "---",
      "Assigned To": (row) => row?.assignedSeller || "----",
      Note: (row) => row?.note || "----",
      isMemberDeleted: (row) => (row.isDeleted ? "DELETED" : "--"),

    },
  },
};

const exportDropdownListitems = [
  {
    innertitle: "Excel",
    svg: require("../../../../assets/images/excel.svg"),
  },

  {
    svg: require("../../../../assets/images/pdf.svg"),
    innertitle: "Pdf",
  },
];
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class ReportExportBootstrap {
  constructor(type, data, currentTab, from, to, gymName) {
    this.type = type;
    this.data = data;
    this.currentTab = currentTab;
    this.fromDate = from;
    this.toDate = to;
    this.gymName = gymName;
    console.log({ type, data, currentTab });
  }

  getColumnsLabels = () => [
    "ID",
    "Package Name",
    "Member Name",
    "Purchase Date",
    "Subscription Status",
    "Start Date",
    "End Date",
    "Price",
    "Discount Amount",
    "Subtotal",
    "Received Amount",
    "Remaining Amount",
    "Return Amount",
    "Voided Amount",
    "Net Amount",
    "Payment Type",
    "Upgraded From Package Name",
    "Upgraded To Package Name",
    "Transfered From Member",
    "Transfered To Member",
    "Note",
    "Created By",
    "Assigned Trainer",
    "isMemberDeleted"
  ];

  getRetailReportColumns = () => [
    "ID",
    "Product Name",
    "Product Category",
    "Member Name",
    "Purchase Date",
    "Status",
    "Price",
    "Cost",
    "Quantity",
    "Discount Amount",
    "Subtotal",
    "Payment Type",
    "Received Amount",
    "Returned Amount",
    "Net Amount",
    "Remaining Amount",
    "Created By",
    "Assigned To",
    "Note",
    "isMemberDeleted"

  ];

  getjfReportColumns = () => [
    "ID",
    "Member Name",
    "Joining Date",
    "Payment Type",
    "Received Amount",
    "isMemberDeleted"

  ];

  //Excel Starts Here

  transposeRowsToCols = (arr) => {
    const rawTransposed = [];

    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr[i].length; j++) {
        if (!rawTransposed[j]) rawTransposed[j] = [];
        rawTransposed[j][i] = arr[i][j];
      }
    }

    return rawTransposed;
  };

  exportToExcel() {
    const sheetName = "Sheet1";
    let name = `Details:${this.currentTab}-${moment().format(
      "DD-MM-YYYY hh:mm:ss A"
    )}.xlsx`;
    if (this.fromDate && this.toDate && this.gymName) {
      name = ` ${this.gymName} : Details:${this.currentTab}-from ${moment(
        this.fromDate
      ).format("DD-MM-YYYY")}-to ${moment(this.toDate).format(
        "DD-MM-YYYY"
      )}.xlsx`;
    }
    const filename = name;
    let reportLabels = this.getColumnsLabels();
    console.log({ type: this.type });
    if (this.currentTab == "retail") {
      reportLabels = this.getRetailReportColumns();
    } else if (this.currentTab == "jf") {
      reportLabels = this.getjfReportColumns();
    }

    let exportedData = reportLabels.map((i) =>
      this.data.map((row) => values[this.type][this.currentTab][i](row))
    );

    for (let idx in exportedData) {
      exportedData[idx].unshift(reportLabels[idx]);
    }

    const transposed = this.transposeRowsToCols(exportedData);

    const worksheet = XLSX.utils.aoa_to_sheet(transposed);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, filename);
  }

  // PDF Starts Here

  pdfDocDefinition = () => {
    return {
      pageSize: "A3",
      pageOrientation: "portrait",
      pageBreakBefore: (currentNode, followingNodesOnPage) => {
        return (
          currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
        );
      },
      content: [
        {
          text: "Connect To Fit",
          style: "title",
          alignment: "center",
        },
        // Table Starts Here
        {
          table: {
            headerRows: 1,
            widths: "*",
            body: [
              this.getColumnsLabels().map((label) => {
                return { text: label, style: "tableHeader" };
              }),
              this.getColumnsLabels().map((i) =>
                this.data.map((row) =>
                  values[this.type][this.currentTab][i](row)
                )
              ),
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function (i, node) {
              return "#ffffff";
            },
            vLineColor: function (i, node) {
              return "#ffffff";
            },
            fillColor: function (rowIndex) {
              if (rowIndex === 0) return rowIndex % 2 === 0 ? "#2d4154" : null;
              return rowIndex % 2 === 0 ? "#ffffff" : "#f3f3f3";
            },
          },
        },
      ],
      // Table Ends Here
      styles: {
        tableHeader: { fontSize: 12, bold: true, color: "white" },
        creatorTitle: {
          margin: [0, 0, 0, 35],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 15],
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 13, 0, 5],
        },
        content: {
          fontSize: 14,
          bold: false,
          // margin: [0, 13, 0, 5],
        },
        metricTitle: {
          fontSize: 16,
          bold: false,
          margin: [0, 10, 0, 5],
        },
        title: {
          fontSize: 28,
          bold: true,
          margin: [0, 10, 0, 25],
        },
      },
    };
  };

  downloadPDF = () => {
    pdfMake.createPdf(this.pdfDocDefinition()).download();
  };
}

export const ExportButton = ({ type, data, currentTab, from, to, gymName }) => {
  const [dropdownOpen, setDropDownOpen] = React.useState(false);
  const [exportAll, setExportAll] = React.useState(false);
  const [action, setAction] = React.useState("");

  const { accountingDetails, reportQuery } = useSelector(
    (state) => state.report
  );
  const toggle = () => {
    setDropDownOpen((prevState) => !prevState);
  };
  const dispatch = useDispatch();

  const getAllDetails = async () => {
    console.log({ reportQuery });
    let query = { category: currentTab };
    if (reportQuery?.startDate) {
      query.startDate = reportQuery?.startDate;
    }
    if (reportQuery?.endDate) {
      query.endDate = reportQuery?.endDate;
    }
    dispatch(
      getAccountingReportDetails({
        limit: accountingDetails?.totalCount,
        page: 1,
        query: { ...reportQuery, ...query },
      })
    );
  };
  const handleClick = async (click) => {
    let report = new ReportExportBootstrap(
      type,
      accountingDetails?.data,
      currentTab,
      from,
      to,
      gymName
    );
    switch (click) {
      case "Pdf": {
        report.downloadPDF();

        break;
      }
      case "Excel": {
        report.exportToExcel();

        break;
      }

      default:
        return;
    }
    setExportAll(false);
    setAction("");
  };
  React.useEffect(() => {
    if (exportAll) {
      getAllDetails();
    }
  }, [exportAll]);
  React.useEffect(() => {
    if (action) {
      handleClick(action);
    }
  }, [accountingDetails?.data]);
  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle className="report-top-button-width" caret>
        Export Data
      </DropdownToggle>
      <DropdownMenu className="custom-dropdown-block">
        <div className="sub-title">Export To</div>
        {exportDropdownListitems.map((items, idx) => (
          <DropdownItem
            onClick={() => {
              setExportAll(true);
              setAction(items.innertitle);
            }}
            key={idx}
          >
            <span>
              <img alt="" src={items.svg} className="img-fluid" />
            </span>
            {items.innertitle}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};
